import {
  ScgpUserStatus,
  useScgpUserFirstLoginUpdateMutation
} from "@saleor/graphql";
import useNavigator from "@saleor/hooks/useNavigator";
import { SetPasswordData } from "@saleor/sdk";
import { parse as parseQs } from "qs";
import React, { useState } from "react";
import { RouteComponentProps } from "react-router";

import ChangePasswordPage, {
  NewPasswordPageFormData
} from "../components/ChangePasswordPage";
import { updateEmailPath } from "../urls";
import { setTokens } from "../utils";

const ChangePassword: React.FC<RouteComponentProps> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<SetPasswordData["errors"]>([]);
  const navigate = useNavigator();
  const [changePassword] = useScgpUserFirstLoginUpdateMutation({
    onCompleted: data => {
      if (!data?.scgpUserFirstLoginUpdate?.errors?.length) {
        if (
          data.scgpUserFirstLoginUpdate?.status ===
          ScgpUserStatus.FORCE_ADD_EMAIL
        ) {
          navigate(
            `${updateEmailPath}?token=${data?.scgpUserFirstLoginUpdate?.tempToken}&username=${data?.scgpUserFirstLoginUpdate?.username}`,
            { replace: true }
          );
        } else {
          setTokens(
            data?.scgpUserFirstLoginUpdate?.token,
            data?.scgpUserFirstLoginUpdate?.csrfToken,
            data?.scgpUserFirstLoginUpdate?.refreshToken,
            false
          );
          navigate("/", { replace: true });
        }
      }
      setErrors(data.scgpUserFirstLoginUpdate.errors as any);
    }
  });

  const handleSubmit = async (data: NewPasswordPageFormData) => {
    setLoading(true);
    changePassword({
      variables: {
        password: data.password,
        confirmPassword: data.confirmPassword,
        tempToken: qs?.token,
        username: qs?.email
      }
    });
  };

  return (
    <>
      <ChangePasswordPage
        errors={errors}
        disabled={loading}
        onBack={() => navigate("/")}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default ChangePassword;
